import React from "react";
import { Home, Projects, Contact, About, Footer } from "./pages";
import { Navibar } from "./container";
import history from "./history";

class App extends React.Component {
  constructor() {
    super();
    this.state = { checked: false };
  }

  handleChange = (checked) => {
    this.setState({ checked });
  };

  render() {
    return (
      <div style={{ height: "100%" }}>
        <Navibar
          handleChange={this.handleChange}
          checked={this.state.checked}
        />
        <Home
          switchState={this.state.checked}
          onEnterViewport={() => {
            history.push("/#home");
          }}
        />

        <About
          onEnterViewport={() => {
            history.push("/#about");
          }}
        />

        <Projects
          onEnterViewport={() => {
            history.push("/#projects");
          }}
        />

        <Contact
          onEnterViewport={() => {
            history.push("/#contact");
          }}
        />
        <Footer />
      </div>
    );
  }
}
export default App;
